import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Route } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from "react-transition-group"

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import TopBar from '../components/AppBar'
import Container from '../components/Container'
import libraryService from '../services/libraryService'
import { materialStatusService, materialSituationsService, materialTypesService } from '../services/materialService'
import { repositoryItemTypeService } from '../services/repositoryService'
import { SET_MATERIAL_STATUS, SET_MATERIAL_SITUATIONS, SET_LIBRARIES, SET_MATERIAL_TYPES, SET_REPOSITORY_ITEM_TYPES } from '../actions/actionTypes'


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#89b1e0',
      main: '#164194',
      dark: '#2c63a4',
    },
    secondary: {
      light: '#052a28',
      main: '#0095DB',
      dark: '#17cac2',
    },
    error: {
      light: '#db9296',
      main: '#c8585e',
      dark: '#a0343a',
    },
  },
  status: {
    danger: 'orange',
  },
});

function App() {
  const dispatch = useDispatch()
  const libraryState = useSelector(state => state.library)
  const materialState = useSelector(state => state.material);
  const repositoryState = useSelector(state => state.repository);

  const fetchLibraries = () => {
    libraryService()
    .then(result => dispatch(
      {type: SET_LIBRARIES, payload: result.data}
    ))
  }

  const fetchMaterialTypes = () => {
    materialTypesService()
    .then(result => dispatch({type: SET_MATERIAL_TYPES, payload: result.data}))
    .catch(error => console.log(error))
  }

  const fetchMaterialStatus = () => {
    materialStatusService()
    .then(response => dispatch(
        {type: SET_MATERIAL_STATUS, payload: response.data}
    ))
  }

  const fetchMaterialSituations = () => {
    materialSituationsService()
    .then(response => dispatch(
        {type: SET_MATERIAL_SITUATIONS, payload: response.data}
    ))
  }

  const fetchRepositoryItemTypes = () => {
    repositoryItemTypeService()
    .then(response => dispatch(
        {type: SET_REPOSITORY_ITEM_TYPES, payload: response.data}
    ))
  }

  useEffect(() => {
    if(!libraryState.list.length)
      fetchLibraries()

    if(!materialState.types.length) 
      fetchMaterialTypes()

    if (!materialState.status.length)
      fetchMaterialStatus()

    if (!materialState.situations.length)
      fetchMaterialSituations()

    if (!repositoryState.itemTypes.length)
        fetchRepositoryItemTypes()

  }, [])

  return (
    <ThemeProvider theme={theme}>
        <Route
          render={({ location }) => (
            <TransitionGroup>
              <TopBar location={location} />
              <CSSTransition
                key={location.pathname}
                exit={false}
                classNames="fade"
                timeout={300}
              >
                <Container location={location} />
              </CSSTransition>
            </TransitionGroup>
          )}
        />
    </ThemeProvider>
  );
}

export default App;
